import React from 'react'
import { SkeletonComponent } from '@syncfusion/ej2-react-notifications'
import { Col, Container, Row } from 'react-bootstrap'

const AppointmentSkeleton: React.FC = (): React.ReactElement => {
  return (
    <Container fluid className="appt-calendar-skeleton">
      <Row className="my-2 mx-1">
        <Col md={6}>
          <Row>
            <div
              className="d-flex align-items-center border rounded p-3"
              style={{
                width: '65px',
                height: '32px',
                border: '1px solid #EFF1F3',
              }}
            >
              <SkeletonComponent shape="Rectangle" height="15px" />
            </div>
            <div
              className="d-flex align-items-center rounded-start p-2 ms-2"
              style={{
                width: '64px',
                height: '32px',
                backgroundColor: '#EFF1F3',
              }}
            >
              <SkeletonComponent shape="Rectangle" height="15px" />
            </div>
            <div
              className="d-flex align-items-center rounded p-2"
              style={{ width: '64px', height: '32px' }}
            >
              <SkeletonComponent shape="Rectangle" height="15px" />
            </div>
            <div
              className="d-flex align-items-center rounded-end p-2"
              style={{ width: '64px', height: '32px' }}
            >
              <SkeletonComponent shape="Rectangle" height="15px" />
            </div>
            <div
              style={{
                width: '1px',
                height: '32px', // Adjust height as needed
                backgroundColor: '#AAAEB6', // Adjust color as needed
                marginRight: '8px', // Spacing from the next element
                padding: 0,
              }}
            />
            <div
              className="d-flex align-items-center border rounded p-2 pe-4"
              style={{
                width: '128px',
                height: '32px',
                border: '1px solid #EFF1F3',
              }}
            >
              <SkeletonComponent shape="Rectangle" height="15px" />
            </div>
          </Row>
        </Col>
        <Col md={6} className="text-end">
          <Row className="d-inline-flex">
            <div
              className="d-flex align-items-center  rounded p-2"
              style={{ width: '84px', height: '32px' }}
            >
              <SkeletonComponent shape="Rectangle" height="15px" />
            </div>
            <div
              className="d-flex align-items-center border rounded p-2 pe-4 ms-2 me-2"
              style={{
                width: '128px',
                height: '32px',
                border: '1px solid #EFF1F3',
              }}
            >
              <SkeletonComponent shape="Rectangle" height="15px" />
            </div>
            <div
              style={{
                width: '1px',
                height: '32px', // Adjust height as needed
                backgroundColor: '#AAAEB6', // Adjust color as needed
                marginRight: '8px', // Spacing from the next element
                padding: 0,
              }}
            />
            <div
              className="d-flex align-items-center rounded pt-2 pb-2 ps-4 pe-4"
              style={{
                width: '137px',
                height: '32px',
                backgroundColor: '#D2D5DB',
              }}
            >
              <SkeletonComponent shape="Rectangle" height="15px" />
            </div>
            <div
              className="d-flex align-items-center border rounded pt-2 pb-2 ps-4 pe-4 ms-2"
              style={{
                width: '103px',
                height: '32px',
                border: '1px solid #EFF1F3',
              }}
            >
              <SkeletonComponent shape="Rectangle" height="15px" />
            </div>
          </Row>
        </Col>
      </Row>
      <Row>
        {/* Left Column */}
        <Col md="auto" className="p-0">
          <div
            className="d-flex align-items-center rounded p-2"
            style={{ width: '48px', height: '48px' }}
          >
            <SkeletonComponent shape="Rectangle" height="15px" />
          </div>
          {Array.from({ length: 14 }).map((_, index) => (
            <div
              key={index}
              className="d-flex align-items-start text-center rounded p-2"
              style={{ width: '48px', height: '48px' }}
            >
              <SkeletonComponent shape="Rectangle" height="15px" width="28px" />
            </div>
          ))}
        </Col>

        {/* Bottom Row */}
        <Col className="d-flex flex-row flex-wrap justify-content-between">
          {Array.from({ length: 5 }).map((_, index) => (
            <div
              key={index}
              className="d-flex align-items-center mx-2"
              style={{ width: 'auto', height: '48px' }}
            >
              <SkeletonComponent
                shape="Circle"
                height="15px"
                width="15px"
                style={{ marginTop: '8px' }}
                className={`${index === 0 && 'd-none'}`}
              />
              <div
                className="d-flex flex-column"
                style={{ marginLeft: '16px' }}
              >
                <SkeletonComponent
                  shape="Rectangle"
                  height="15px"
                  width="100px"
                />
                <SkeletonComponent
                  shape="Rectangle"
                  height="15px"
                  width="150px"
                  style={{ marginTop: '8px' }}
                />
              </div>
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  )
}

export default AppointmentSkeleton
